import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { BoldTailHeading } from '~/utils/boldTailHeading'
import './SupportSustainability.css'

function Heading({ text }) {
  return (
    <h3 className="support-sustainability__heading">
      <BoldTailHeading text={text} />
    </h3>
  )
}

function Row({ row, altText }) {
  const heading = row?.textCard?.heading?.text
  const content = row?.textCard?.content
  const image = row?.image
  const reverse = row?.alignImage === 'right'

  return (
    <div className={`support-sustainability__row ${reverse ? 'support-sustainability__row--reverse' : ''}`}>
      <div className="support-sustainability__media">
        <FadeInWhenVisible className="w-full h-full">
          {image && (
            <Image
              data={{ ...image, altText: image?.altText || altText }}
              className="support-sustainability__image"
            />
          )}
        </FadeInWhenVisible>
      </div>
      <div className="support-sustainability__content">
        {heading && (
          <FadeInWhenVisible>
            <Heading text={heading} />
          </FadeInWhenVisible>
        )}
        {content && (
          <FadeInWhenVisible transition={{ delay: '.1' }}>
            <div
              className="support-sustainability__body"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </FadeInWhenVisible>
        )}
      </div>
    </div>
  )
}

export default function SupportSustainability({ index, row1, row2 }) {
  if (!row1 && !row2) return null

  return (
    <section id={`support-sustainability${index ?? ''}`} className="support-sustainability">
      {row1 && <Row row={row1} altText="City Relay managed bedroom" />}
      {row2 && <Row row={row2} altText="City Relay managed living room" />}
    </section>
  )
}
